<template>
  <div class="sm-notification-top terms">
    <div class="sm-wrap">
      <div class="sm-notification-top__terms" @click="handleClick">
        <include-svg :name="'icon-nexudus'" />
        <span class="sm-small">
          Connect Nexudus — 
          <a
            class="sm-txt-small"
            target="_blank"
            href="https://support.spheremail.co/support/solutions/articles/69000842284-linking-nexudus-to-your-spheremail-portal%E2%86%92"
          >
            Learn more
          </a>
        </span>
        <a
          href="#"
          class="sm-notification-top__terms-close"
          @click.stop="$emit('close')"
        >
          <include-svg :name="'icon-action-close'" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nexudus-notification",
  methods: {
    handleClick() {
      this.$router.push("/admin/settings?tab=other&view=systems");

      this.$emit("close");
    },
  },
};
</script>